import { NLogin, useNostrLogin } from "@nostrify/react/login";
import { useNostr } from "@nostrify/react";

/**
 * Login action wrappers around Nostrify's login state machine.
 * Ported (simplified) from treasures.to — supports browser extension,
 * nsec, and bunker:// remote signers.
 */
export function useLoginActions() {
  const { nostr } = useNostr();
  const { logins, addLogin, removeLogin } = useNostrLogin();

  return {
    nsec(nsec: string): void {
      addLogin(NLogin.fromNsec(nsec));
    },
    async bunker(uri: string): Promise<void> {
      addLogin(await NLogin.fromBunker(uri, nostr));
    },
    async extension(): Promise<void> {
      addLogin(await NLogin.fromExtension());
    },
    logout(): void {
      const login = logins[0];
      if (login) removeLogin(login.id);
    },
  };
}
